import { useState } from "react";
import { WIKI_CATEGORIES } from "../data/wiki";

export default function Wiki() {
  const [lang, setLang] = useState(
    () => localStorage.getItem("wiki_lang") || "en"
  );
  const [expanded, setExpanded] = useState(new Set());

  function toggleLang(l) {
    setLang(l);
    localStorage.setItem("wiki_lang", l);
  }

  function toggleEntry(key) {
    setExpanded(prev => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  }

  return (
    <div style={{ fontFamily: "'Georgia', serif", background: "var(--bg-page)", minHeight: "100vh", paddingBottom: 40 }}>
      {/* Header */}
      <div style={{ background: "#1A1A2E", padding: "20px 20px 16px" }}>
        <div style={{ maxWidth: 600, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
          <div>
            <div style={{ color: "rgba(255,255,255,0.5)", fontSize: 11, letterSpacing: 2, fontFamily: "monospace" }}>RUNNER'S WIKI</div>
            <div style={{ color: "#fff", fontSize: 18, fontWeight: "bold", marginTop: 3 }}>Knowledge Base</div>
            <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 12, marginTop: 2 }}>
              {lang === "en" ? "Tap any term to expand" : "Koppints a fogalomra a kibontáshoz"}
            </div>
          </div>
          {/* Language toggle */}
          <div style={{ display: "flex", gap: 4 }}>
            {["en", "hu"].map(l => (
              <button
                key={l}
                onClick={() => toggleLang(l)}
                style={{
                  padding: "6px 12px",
                  borderRadius: 6,
                  border: "none",
                  background: lang === l ? "#16A085" : "rgba(255,255,255,0.1)",
                  color: lang === l ? "#fff" : "rgba(255,255,255,0.5)",
                  fontFamily: "'Georgia', serif",
                  fontSize: 12,
                  fontWeight: lang === l ? "bold" : "normal",
                  cursor: "pointer",
                }}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Categories */}
      <div style={{ maxWidth: 600, margin: "0 auto", padding: "20px 16px" }}>
        {WIKI_CATEGORIES.map(cat => (
          <div key={cat.id} style={{ marginBottom: 28 }}>
            {/* Category header */}
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
              <span style={{ fontSize: 18 }}>{cat.icon}</span>
              <span style={{ fontSize: 11, fontWeight: "bold", color: "var(--text-subtle)", letterSpacing: 1.5, fontFamily: "monospace" }}>
                {cat.title[lang].toUpperCase()}
              </span>
            </div>
            {/* Entries */}
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {cat.entries.map((entry, i) => {
                const key = `${cat.id}:${i}`;
                const isOpen = expanded.has(key);
                return (
                  <div
                    key={i}
                    style={{
                      border: "1px solid var(--border)",
                      borderRadius: 8,
                      overflow: "hidden",
                      background: "var(--bg-card)",
                    }}
                  >
                    <div
                      onClick={() => toggleEntry(key)}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px 14px",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                    >
                      <span style={{ fontSize: 13, fontWeight: "bold", color: "var(--text-primary)" }}>
                        {entry.term[lang]}
                      </span>
                      <span style={{ fontSize: 11, color: "#bbb", flexShrink: 0, marginLeft: 8 }}>
                        {isOpen ? "▲" : "▼"}
                      </span>
                    </div>
                    {isOpen && (
                      <div
                        style={{
                          padding: "8px 14px 12px",
                          borderTop: "1px solid var(--border)",
                          fontSize: 13,
                          color: "var(--text-muted)",
                          lineHeight: 1.65,
                        }}
                      >
                        {entry.def[lang]}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
